document.addEventListener("DOMContentLoaded", function () {
  const swiper = new Swiper(".aero-pro-layout-content-mobile", {
    spaceBetween: 10,
    slidesPerView: 1.2,
    slidesOffsetBefore: 16,
    slidesOffsetAfter: 16,
    pagination: {
      el: ".aero-pro-swiper-pagination",
      type: "bullets",
    },
    autoplay: {
      delay: 3000,
    },
  });

  swiper &&
    swiper.on("autoplayStart", () => {
      swiper.el && swiper.el.classList.remove("swiper-autoplay-paused");
    });

  swiper &&
    swiper.on("autoplayStop", () => {
      swiper.el && swiper.el.classList.add("swiper-autoplay-paused");
    });

  $(".aero-pro-layout .aero-pro-layout-item").on("click", function () {
    const className = $(this).data("jump-class");
    if (!className) return;

    const $target = $("body")
      .find("." + className)
      .first();
    if (!$target.length) return;

    $("html, body").animate(
      {
        scrollTop: $target.offset().top,
      },
      300,
    );
  });
});
